
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.497 10.015a.751.751 0 00-.538.22.751.751 0 000 1.063l2.474 2.473-2.474 2.472a.751.751 0 000 1.064.751.751 0 001.065 0l2.472-2.473 2.472 2.474a.751.751 0 001.065 0 .751.751 0 000-1.064L6.56 13.771l2.473-2.472a.751.751 0 000-1.064.751.751 0 00-.526-.22.751.751 0 00-.539.22l-2.472 2.472-2.472-2.472a.751.751 0 00-.526-.22z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.496 0a2.754 2.754 0 00-2.754 2.754v6.01h1.502v-6.01c0-.69.561-1.252 1.252-1.252h4.695a.75.75 0 00-.054.28v2.122a2.754 2.754 0 002.754 2.754h1.87v8.588c0 .69-.562 1.252-1.253 1.252h-3.004V18h3.004a2.754 2.754 0 002.754-2.754V5.84a2.754 2.754 0 00-.704-1.838L12.792.915A2.754 2.754 0 0010.742 0zm6.143 3.904V1.883l.035.035 2.766 3.087c.043.047.082.098.116.15h-1.664a1.252 1.252 0 01-1.252-1.252z","clip-rule":"evenodd"}})])
          )
        }
      }
    